import script from "./RoomSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoomSearch.vue?vue&type=script&lang=ts&setup=true"

import "./RoomSearch.vue?vue&type=style&index=0&id=3ff3f20d&lang=scss"

const __exports__ = script;

export default __exports__